import { Navigate, Outlet } from 'react-router-dom';
import authStorage from "../utils/authStorage";

const PrivateRoute = () => {
  const isAuthenticated = authStorage.getItem("auth-token"); // Replace with your authentication logic

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;